import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { SystemDownIcon } from "ksc-portal-common-components/atoms"
import { SCHEDULED_MAINTENANCE, SERVICE_FAILURE } from "./constants"

const SystemDown = ({
  type = SERVICE_FAILURE,
}: {
  type: string
}): JSX.Element => {
  const [animate, setAnimate] = useState<boolean>(true)
  let message = (
    <>
      Apologies, the system is unavailable at present. <br /> We are working to
      resolve the issue.
    </>
  )

  if (type === SCHEDULED_MAINTENANCE) {
    message = (
      <>
        Apologies, the system is unavailable at <br /> present due to scheduled
        maintenance. <br /> We should resume our service shortly.
      </>
    )
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(false) // Disable animation after 2 seconds
    }, 2000)
    return () => {
      clearTimeout(timer) // Clear the timeout if the component is unmounted
    }
  }, [])

  return (
    <div className="system-down">
      <div
        className={`system-down__card ${
          animate ? "system-down__shaking" : ""
        } ${
          document.title === "Single Rulebook"
            ? "system-down__srb-card"
            : "system-down__hub-card"
        }`}
        data-testid={`${
          document.title === "Single Rulebook"
            ? "system-down__srb-card"
            : "system-down__hub-card"
        }`}
      >
        <div
          className={`system-down__card-logo-container ${
            document.title === "Single Rulebook"
              ? "system-down__srb-card-logo-container"
              : "system-down__hub-card-logo-container"
          }`}
        >
          {document.title === "Single Rulebook" ? (
            <div id="logo" className="system-down__logo" />
          ) : (
            <SystemDownIcon />
          )}
        </div>
        <h5 className="system-down__message">{message}</h5>
        {document.title === "Single Rulebook" && (
          <div className="system-down__link-container">
            <p>Find out more at:</p>
            <Link
              className="system-down__link"
              to={{ pathname: "https://singlerulebook.statuspage.io/" }}
              target="_blank"
            >
              https://singlerulebook.statuspage.io/
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default SystemDown
